<div class="animate-fade-in w-full space-y-6">
  <!-- Title -->
  <div class="text-center md:text-left">
    <h2 class="mb-2 text-2xl font-bold text-greyscale-900">
      {{ "accessRequestSent.title" | transloco }}
    </h2>
  </div>

  <!-- Content -->
  <div class="w-full space-y-4">
    <p class="text-center text-paragraph-reg text-greyscale-600 md:text-left">
      {{ "accessRequestSent.subtitle" | transloco }}
      <strong class="text-greyscale-900">{{ companyName() }}</strong>
    </p>

    <!-- What happens next -->
    <div class="rounded-md bg-greyscale-50 p-4">
      <h3 class="mb-3 font-medium text-greyscale-900">
        {{ "accessRequestSent.whatHappensNext" | transloco }}
      </h3>
      <div class="space-y-3 text-paragraph-reg text-greyscale-700">
        <p class="flex items-start">
          <i class="pi pi-envelope mr-3 mt-1 text-primary-500"></i>
          <span>{{ "accessRequestSent.step1" | transloco }}</span>
        </p>
        <p class="flex items-start">
          <i class="pi pi-user-plus mr-3 mt-1 text-primary-500"></i>
          <span>{{ "accessRequestSent.step2" | transloco }}</span>
        </p>
        <p class="flex items-start">
          <i class="pi pi-key mr-3 mt-1 text-primary-500"></i>
          <span>{{ "accessRequestSent.step3" | transloco }}</span>
        </p>
        <p class="flex items-start">
          <i class="pi pi-sign-in mr-3 mt-1 text-primary-500"></i>
          <span>{{ "accessRequestSent.step4" | transloco }}</span>
        </p>
      </div>
    </div>

    <!-- Info box - Contact -->
    <div class="rounded-md border border-primary-200 bg-primary-50 p-4">
      <p class="flex items-start text-paragraph-s-reg text-primary-800">
        <i class="pi pi-info-circle mr-2 mt-0.5"></i>
        <span
          >{{ "accessRequestSent.contactSupport" | transloco }}
          <a
            href="mailto:info@greentripper.com"
            class="font-medium underline"
            >{{ "info@greentripper.org" }}</a
          ></span
        >
      </p>
    </div>
  </div>

  <!-- Back to login button -->
  <div class="flex flex-col items-center gap-2 md:items-start">
    <button
      type="button"
      (click)="goToLogin()"
      class="flex w-full justify-center rounded-md border border-transparent bg-primary-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
    >
      {{ "accessRequestSent.backToLogin" | transloco }}
    </button>
  </div>
</div>
